import { useState, useEffect } from "react";

interface StickyMobileCTAProps {
  onRequestLeads: () => void;
}

export default function StickyMobileCTA({ onRequestLeads }: StickyMobileCTAProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className={`md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-100 px-4 py-3 transition-transform duration-300 ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <button
        onClick={onRequestLeads}
        className="w-full bg-green-500 hover:bg-green-400 text-black font-bold py-3.5 rounded-full text-sm transition-all duration-200 active:scale-95 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
      >
        Request Sample Leads
        <i className="ri-arrow-right-line text-base"></i>
      </button>
    </div>
  );
}
